import { render, staticRenderFns } from "./AdvertisersAffiliates.vue?vue&type=template&id=36e8f364&scoped=true&"
import script from "./AdvertisersAffiliates.vue?vue&type=script&lang=ts&"
export * from "./AdvertisersAffiliates.vue?vue&type=script&lang=ts&"
import style0 from "./AdvertisersAffiliates.vue?vue&type=style&index=0&id=36e8f364&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e8f364",
  null
  
)

export default component.exports